import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// app.css was split into ordered modules (css-file-split). Import order is
// load-bearing — it reproduces the original single-file cascade exactly
// (tokens first; cell-types LAST so its EOF rules still win by source order).
// states.css stays last, after every app module, as it always was.
import "./styles/app/01-tokens-base.css";
import "./styles/app/02-shell.css";
import "./styles/app/03-bookings.css";
import "./styles/app/04-drawers.css";
import "./styles/app/05-today.css";
import "./styles/app/06-dogs-owners.css";
import "./styles/app/07-finances-messages.css";
import "./styles/app/08-account.css";
import "./styles/app/09-controls.css";
import "./styles/app/10-rota.css";
import "./styles/app/11-drawer-modal.css";
import "./styles/app/12-mobile.css";
import "./styles/app/13-tail-finances.css";
// New global-chrome modules (app-shell-redesign) — named concern-modules, the
// target structure the legacy numbered split converges to. Unique class names,
// so import position is not cascade-critical; grouped here before cell-types.
import "./styles/app/topbar.css";
import "./styles/app/date-picker.css";
import "./styles/app/list-page.css";
import "./styles/app/filters.css";
import "./styles/app/search.css";
// App access — the household modal's third column (household-app-access).
// Scoped to .obx like the rest of the modal, so import position is not
// cascade-critical; it sits with the other numbered modules.
import "./styles/app/15-access.css";
import "./styles/app/16-notifications.css";
// The message page — a centred column that says one thing and offers what to
// do about it (components/common/MessagePage.tsx). Global, its own classes.
import "./styles/app/message-page.css";
// The drawer — the app's one bottom sheet (components/common/Drawer.tsx).
// Global, its own classes.
import "./styles/app/sheet.css";
import "./styles/app/14-cell-types.css";
import "./styles/states.css";
// The CUSTOMER app's own shell — its own roots (.cp-page, .cp-app), sharing
// this app's tokens and none of its chrome.
import "./styles/customer.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
